var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.route}}},[_c('li',{class:_vm.useClass},[(_vm.hasLabel)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),(!_vm.hasLabel)?_c('i',{staticClass:"la",class:_vm.icon}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }